<app-side-panel
  [table]="TABLES.DELETED"
  [trackTable]="true"
  [showFraud]="true"
  (changeColorCoding)="changeColorCoding($event)">
</app-side-panel>
<mat-drawer-container class="delete-screen">
  <mat-drawer-content>
    <div [ngClass]="loading ? 'disabledbtn' : ''">
      <div class="delete-screen__title">Deleted Orders</div>
      <div class="delete-screen__subtitle">Removed from PDQ but not Shopify</div>

      <div class="delete-screen__tabs"></div>

      <div class="delete-screen__tabs-lower">
        <div class="delete-screen__free-search">
          <app-newui-search-autocomplete
            (searchResultsToTable)="onSearchToTable($event)"
            [table]="TABLES.DELETED"
            [showDeletedOrders]="true">
          </app-newui-search-autocomplete>
        </div>
      </div>

      <div class="delete-table-container" [ngClass]="{ previewLoading: yellowPB }">
        <app-table
          [table]="TABLES.DELETED"
          [selected]="selectedOrders"
          [rows]="temp"
          [rowActions]="rowActions"
          [groupActions]="groupActions"
          [columnsSettings]="columns"
          [focusedRowId]="focusedOrderId"
          [rowsLoading]="loading"
          [yellowProgressBar]="yellowPB"
          [perPageActiveOption]="ordersPerPage"
          [totalCountOrders]="totalCountOrders"
          [allPages]="allPages"
          [activePage]="activePage"
          [totalPages]="totalPages"
          [paginationMode]="useCursorPagination() ? 'cursor' : 'offset'"
          [cursorRangeLabel]="deliverCursorPagination.rangeLabel()"
          [cursorHasNextPage]="deliverCursorPagination.hasNextPage()"
          [cursorHasPreviousPage]="deliverCursorPagination.hasPreviousPage()"
          [totalCountDisplay]="useCursorPagination() ? deliverCursorPagination.totalCountDisplay() : null"
          (cursorPageChange)="onCursorPageChange($event)"
          [message]="chooseEmptyMessage()"
          (sort)="sortColumns($event)"
          (changeSelectedOrders)="onSelect($event)"
          (changeFilter)="onChangeTableFilter($event)"
          (onTableActivate)="onTableActivate($event)"
          (changePerPage)="onChangeOrdersPerPage($event)"
          (changePage)="paginate($event)"
          (jumpToPage)="jumpToPage($event)"
          (restoreOrder)="onRestoreOrder($event)"
          (changeColorCoding)="changeColorCoding($event)">
        </app-table>
      </div>
    </div>
  </mat-drawer-content>
</mat-drawer-container>
